/**
 * EAN-13 helper: generator + validator met mod-10 checksum.
 *
 * Interne prefix `20` wordt gebruikt (GS1 voorbehouden voor in-store/internal use,
 * geen registratie vereist — nooit conflicten met gescande retail-producten).
 */

export const EAN13_INTERNAL_PREFIX = '20';

function checksum(digits12) {
  // digits12: string of 12 numeric digits
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const d = parseInt(digits12[i], 10);
    sum += (i % 2 === 0) ? d : d * 3;
  }
  const mod = sum % 10;
  return mod === 0 ? 0 : 10 - mod;
}

/** Genereer een geldige EAN-13. Prefix default = '20' (intern gebruik). */
export function generateEan13(prefix = EAN13_INTERNAL_PREFIX) {
  const pfx = (prefix || '').replace(/\D/g, '').slice(0, 11);
  const need = 12 - pfx.length;
  let body = '';
  for (let i = 0; i < need; i++) body += Math.floor(Math.random() * 10);
  const base = pfx + body;
  return base + checksum(base).toString();
}

/** True wanneer s exact 13 digits is én de checksum klopt. */
export function isValidEan13(s) {
  const t = (s || '').toString().trim();
  if (!/^\d{13}$/.test(t)) return false;
  return checksum(t.slice(0, 12)) === parseInt(t[12], 10);
}
